export default "__VITE_ASSET__BHS9c8px__"